module.exports = __webpack_public_path__ + "static/martin-deerline-logo-38c020c70f82e56476cdf17d68be1827.jpg";